// import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   getAssignDataStart,
//   saveShuffleStart,
// } from "../../../../redux/slices/compaigns/compaignsSlice";
// import {
//   AssignTable,
//   Button,
//   FormFieldSet,
//   InfoCardTwo,
// } from "../../../../components";

// const Assign = () => {
//   const [assignmentOutput, setAssignmentOutput] = useState(null);
//   const [selectedShuffleType, setSelectedShuffleType] = useState("");

//   const { user } = useSelector((state) => state.auth);
//   const assignData = useSelector((state) => state.compaigns?.assignData?.data);

//   const dispatch = useDispatch();

//   const handleAssignmentOutput = (assignments) => {
//     setAssignmentOutput(assignments);
//   };

//   const fetchAssignData = () => {
//     const action = {
//       coll: "Job",
//       queryMode: "AG_ASSIGN",
//       useAggregate: true,
//       fil: JSON.stringify({ dates: { type: "AG_ASSIGN", value: "" } }),
//     };
//     dispatch(getAssignDataStart(action));
//   };

//   const shuffleTypeMap = {
//     raToBdm: 1,
//     equally: 2,
//     range: 3,
//   };

//   const handleSave = () => {
//     if (!assignmentOutput || !assignmentOutput.length) {
//       console.log("No assignments to save");
//       return;
//     }

//     const payload = {
//       coll: "Shuffle",
//       payload: {
//         date: new Date().toISOString(),
//         shuffleType: shuffleTypeMap[selectedShuffleType] || 1,
//         addedBy: Number(user.data.uiid),
//         version: 1,
//         shuffle: assignmentOutput.map((a) => ({
//           BdmId: Number(a.bdm.id),
//           // assignedProspectData: [
//           //   ...(a.teams.senior || []),
//           //   ...(a.teams.junior || []),
//           //   ...(a.teams.fresher || []),
//           // ]
//           //   .flatMap((team) => team.jobProspects || [])

//           //     jobId: Number(jp.jobId),
//           //     prospectId: Number(jp.prospectId),
//           //   })),
//           assignedProspectData: [
//             ...(a.teams.senior || []),
//             ...(a.teams.junior || []),
//             ...(a.teams.fresher || []),
//           ]
//             .flatMap((team) => team.jobProspects || [])
//             .map((jp) => ({
//               jobId: jp.jobId,
//               prospectId: jp.prospectId,
//             })),
//         })),
//       },
//     };

//     console.log("Dispatching saveShuffle payload:", payload);
//     dispatch(saveShuffleStart(payload));
//   };
//   // const handleSave = () => {
//   //   if (!assignmentOutput || !assignmentOutput.length) {
//   //     console.log("No assignments to save");
//   //     return;
//   //   }

//   //   const payload = {
//   //     coll: "Shuffle",
//   //     payload: {
//   //       date: new Date().toISOString(),
//   //       shuffleType: shuffleTypeMap[selectedShuffleType] || 1,
//   //       addedBy: Number(user.data.uiid),
//   //       version: 1,
//   //       shuffle: assignmentOutput.map((a) => {
//   //         const assignedProspects = [
//   //           ...(a.teams.senior || []),
//   //           ...(a.teams.junior || []),
//   //           ...(a.teams.fresher || []),
//   //         ].flatMap((team) => team.jobProspects || []);

//   //         return {
//   //           BdmId: Number(a.bdm.id),
//   //           assignedProspectData:
//   //             assignedProspects.length > 0
//   //               ? assignedProspects.map((jp) => ({
//   //                   jobId: Number(jp.jobId),
//   //                   prospectId: Number(jp.prospectId),
//   //                 }))
//   //               : [
//   //                   {
//   //                     jobId: null,
//   //                     prospectId: null,
//   //                   },
//   //                 ],
//   //         };
//   //       }),
//   //     },
//   //   };

//   //   console.log("Dispatching saveShuffle payload:", payload);
//   //   dispatch(saveShuffleStart(payload));
//   // };

//   useEffect(() => {
//     fetchAssignData();
//   }, [dispatch]);

//   // 🔹 Transform assignData into UI format with jobProspects flattened
//   const transformedData = assignData
//     ? {
//         bdmList: assignData.map((bdm) => ({
//           id: bdm.uiid,
//           name: `${bdm.firstName} ${bdm.lastName}`,
//           email: bdm.email?.primary || "",
//         })),
//         teamList: assignData.flatMap((bdm) =>
//           bdm.raData.flatMap((category) =>
//             (category.users || []).map((user) => ({
//               id: `${user.uiid}`,
//               name: user.firstName,
//               designation:
//                 category.category === 1
//                   ? "fresher"
//                   : category.category === 2
//                   ? "junior"
//                   : "senior",
//               prospectCount: user.jobs?.reduce(
//                 (sum, job) => sum + (job.prospectIds?.length || 0),
//                 0
//               ),
//               assignedTo: bdm.uiid,

//               // ✅ Flatten jobId + prospectId pairs
//               // jobProspects:
//               //   user.jobs?.flatMap((job) =>
//               //     (job.prospectIds || []).map((pid) => ({
//               //       jobId: job.jobId,
//               //       prospectId: pid,
//               //     }))
//               //   ) || [],
//               jobProspects:
//                 user.jobs?.flatMap((job) =>
//                   (job.prospectIds || []).map((pid) => ({
//                     jobId: job.uiid ?? null, // use uiid from job
//                     prospectId: pid ?? null, // keep prospectId
//                   }))
//                 ) || [],
//             }))
//           )
//         ),
//       }
//     : null;

//   const memoizedData = React.useMemo(
//     () => transformedData || [],
//     [transformedData]
//   );

//   const teamList = Array.isArray(memoizedData)
//     ? []
//     : memoizedData.teamList || [];
//   const bdmList = Array.isArray(memoizedData) ? [] : memoizedData.bdmList || [];

//   const designationCounts = teamList.reduce(
//     (acc, team) => {
//       if (team.designation === "senior") acc.senior += 1;
//       else if (team.designation === "junior") acc.junior += 1;
//       else if (team.designation === "fresher") acc.fresher += 1;
//       return acc;
//     },
//     { senior: 0, junior: 0, fresher: 0 }
//   );

//   const totalEmails = teamList.reduce(
//     (sum, team) => sum + (team.prospectCount || team.emailsList?.length || 0),
//     0
//   );

//   return (
//     <div className="px-5 py-3">
//       <div className="flex justify-end my-2">
//         <FormFieldSet
//           title="Shuffle"
//           type="select"
//           placeholder="RA to BDM"
//           options={[
//             { label: "RA to BDM", value: "raToBdm" },
//             { label: "Equally", value: "equally" },
//             { label: "Range", value: "range" },
//           ]}
//           value={selectedShuffleType}
//           onChange={(val) => setSelectedShuffleType(val)}
//         />
//       </div>

//       <div className="grid grid-cols-5 gap-8 my-4">
//         <InfoCardTwo
//           title="Total BDM's"
//           value={bdmList.length}
//           icon="business_center"
//         />
//         <InfoCardTwo
//           title="Senior RA"
//           value={designationCounts.senior}
//           icon="business_center"
//         />
//         <InfoCardTwo
//           title="Junior RA"
//           value={designationCounts.junior}
//           icon="business_center"
//         />
//         <InfoCardTwo
//           title="Fresher RA"
//           value={designationCounts.fresher}
//           icon="business_center"
//         />
//         <InfoCardTwo
//           title="Emails Count"
//           value={totalEmails}
//           icon="business_center"
//         />
//       </div>

//       <div className="w-full overflow-auto">
//         <AssignTable
//           key={JSON.stringify(memoizedData)}
//           data={memoizedData}
//           output={handleAssignmentOutput}
//         />
//       </div>

//       <div className="flex justify-end my-10">
//         <Button title={"Save"} onClick={handleSave} />
//       </div>
//     </div>
//   );
// };

// export default Assign;

// import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   getAssignDataStart,
//   saveShuffleStart,
// } from "../../../../redux/slices/compaigns/compaignsSlice";
// import {
//   AssignTable,
//   Button,
//   FormFieldSet,
//   InfoCardTwo,
// } from "../../../../components";

// const Assign = () => {
//   const [assignmentOutput, setAssignmentOutput] = useState(null);
//   const [selectedShuffleType, setSelectedShuffleType] = useState("");

//   const { user } = useSelector((state) => state.auth);
//   const assignData = useSelector((state) => state.compaigns?.assignData?.data);

//   const dispatch = useDispatch();

//   const handleAssignmentOutput = (assignments) => {
//     setAssignmentOutput(assignments);
//   };

//   const fetchAssignData = () => {
//     const action = {
//       coll: "Job",
//       queryMode: "AG_ASSIGN",
//       useAggregate: true,
//       fil: JSON.stringify({ dates: { type: "AG_ASSIGN", value: "" } }),
//     };
//     dispatch(getAssignDataStart(action));
//   };

//   const shuffleTypeMap = {
//     raToBdm: 1,
//     equally: 2,
//     range: 3,
//   };

//   // 🔹 Save handler
//   const handleSave = () => {
//     if (!assignmentOutput || !assignmentOutput.length) {
//       console.log("No assignments to save");
//       return;
//     }

//     // const payload = {
//     //   coll: "Shuffle",
//     //   payload: {
//     //     date: new Date().toISOString(),
//     //     shuffleType: shuffleTypeMap[selectedShuffleType] || 1,
//     //     addedBy: Number(user.data.uiid),
//     //     version: 1,
//     //     shuffle: assignmentOutput.map((a) => ({
//     //       BdmId: Number(a.bdm.id),
//     //       assignedProspectData: [
//     //         ...(a.teams.senior || []),
//     //         ...(a.teams.junior || []),
//     //         ...(a.teams.fresher || []),
//     //       ].flatMap((team) =>
//     //         (team.jobProspects || []).map((jp) => ({
//     //           userId: Number(team.id), // ✅ include userId
//     //           jobId: Number(jp.jobId) || null,
//     //           prospectId: Number(jp.prospectId) || null,
//     //         }))
//     //       ),
//     //     })),
//     //   },
//     // };

//     const payload = {
//       coll: "Shuffle",
//       payload: {
//         date: new Date().toISOString(),
//         shuffleType: shuffleTypeMap[selectedShuffleType] || 1,
//         addedBy: Number(user.data.uiid),
//         version: 1,
//         shuffle: assignmentOutput.map((a) => ({
//           BdmId: Number(a.bdm.id),
//           assignedProspectData: [
//             ...(a.teams.senior || []),
//             ...(a.teams.junior || []),
//             ...(a.teams.fresher || []),
//           ].flatMap((team) => {
//             const prospects = team.jobProspects || [];
//             if (prospects.length > 0) {
//               return prospects.map((jp) => ({
//                 userId: Number(team.id),
//                 jobId: Number(jp.jobId) || null,
//                 prospectId: Number(jp.prospectId) || null,
//               }));
//             } else {
//               // No job/prospect but still include userId
//               return [
//                 { userId: Number(team.id), jobId: null, prospectId: null },
//               ];
//             }
//           }),
//         })),
//       },
//     };

//     console.log("Dispatching saveShuffle payload:", payload);
//     dispatch(saveShuffleStart(payload));
//   };

//   useEffect(() => {
//     fetchAssignData();
//   }, [dispatch]);

//   // 🔹 Transform assignData into UI format with jobProspects flattened
//   const transformedData = assignData
//     ? {
//         bdmList: assignData.map((bdm) => ({
//           id: bdm.uiid,
//           name: `${bdm.firstName} ${bdm.lastName}`,
//           email: bdm.email?.primary || "",
//         })),
//         teamList: assignData.flatMap((bdm) =>
//           bdm.raData.flatMap((category) =>
//             (category.users || []).map((user) => ({
//               id: `${user.uiid}`,
//               name: user.firstName,
//               designation:
//                 category.category === 1
//                   ? "fresher"
//                   : category.category === 2
//                   ? "junior"
//                   : "senior",
//               prospectCount: user.jobs?.reduce(
//                 (sum, job) => sum + (job.prospectIds?.length || 0),
//                 0
//               ),
//               assignedTo: bdm.uiid,
//               jobProspects:
//                 user.jobs?.flatMap((job) =>
//                   (job.prospectIds || []).map((pid) => ({
//                     jobId: job.uiid ?? null,
//                     prospectId: pid ?? null,
//                   }))
//                 ) || [],
//             }))
//           )
//         ),
//       }
//     : null;

//   const memoizedData = React.useMemo(
//     () => transformedData || [],
//     [transformedData]
//   );

//   const teamList = Array.isArray(memoizedData)
//     ? []
//     : memoizedData.teamList || [];
//   const bdmList = Array.isArray(memoizedData) ? [] : memoizedData.bdmList || [];

//   const designationCounts = teamList.reduce(
//     (acc, team) => {
//       if (team.designation === "senior") acc.senior += 1;
//       else if (team.designation === "junior") acc.junior += 1;
//       else if (team.designation === "fresher") acc.fresher += 1;
//       return acc;
//     },
//     { senior: 0, junior: 0, fresher: 0 }
//   );

//   const totalEmails = teamList.reduce(
//     (sum, team) => sum + (team.prospectCount || 0),
//     0
//   );

//   return (
//     <div className="px-5 py-3">
//       <div className="flex justify-end my-2">
//         <FormFieldSet
//           title="Shuffle"
//           type="select"
//           placeholder="RA to BDM"
//           options={[
//             { label: "RA to BDM", value: "raToBdm" },
//             { label: "Equally", value: "equally" },
//             { label: "Range", value: "range" },
//           ]}
//           value={selectedShuffleType}
//           onChange={(val) => setSelectedShuffleType(val)}
//         />
//       </div>

//       <div className="grid grid-cols-5 gap-8 my-4">
//         <InfoCardTwo
//           title="Total BDM's"
//           value={bdmList.length}
//           icon="business_center"
//         />
//         <InfoCardTwo
//           title="Senior RA"
//           value={designationCounts.senior}
//           icon="business_center"
//         />
//         <InfoCardTwo
//           title="Junior RA"
//           value={designationCounts.junior}
//           icon="business_center"
//         />
//         <InfoCardTwo
//           title="Fresher RA"
//           value={designationCounts.fresher}
//           icon="business_center"
//         />
//         <InfoCardTwo
//           title="Emails Count"
//           value={totalEmails}
//           icon="business_center"
//         />
//       </div>

//       <div className="w-full overflow-auto">
//         <AssignTable
//           key={JSON.stringify(memoizedData)}
//           data={memoizedData}
//           output={handleAssignmentOutput}
//         />
//       </div>

//       <div className="flex justify-end my-10">
//         <Button title={"Save"} onClick={handleSave} />
//       </div>
//     </div>
//   );
// };

// export default Assign;

import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAssignDataStart,
  saveShuffleStart,
} from "../../../../redux/slices/compaigns/compaignsSlice";
import {
  AssignTable,
  Backdrop,
  Button,
  DropdownMenuNew,
  FormFieldSet,
  InfoCardNewAdv,
  InfoCardTwo,
  InfoWrapper,
  LogoLoader,
  showToast,
} from "../../../../components";
import { formatWords2 } from "../../../../utils/stringUtils";

const Assign = () => {
  const [assignmentOutput, setAssignmentOutput] = useState(null);
  const [selectedShuffleType, setSelectedShuffleType] = useState("default");
  const [min, setMin] = useState("");
  const [max, setMax] = useState("");
  const [validatedRange, setValidatedRange] = useState({
    min: null,
    max: null,
  });

  const { user } = useSelector((state) => state.auth);
  const assignData = useSelector((state) => state.compaigns?.assignData?.data);
  const { loading } = useSelector((state) => state?.compaigns);

  const dispatch = useDispatch();

  const handleAssignmentOutput = (assignments) => {
    setAssignmentOutput(assignments);
  };

  const fetchAssignData = () => {
    const action = {
      coll: "Job",
      queryMode: "AG_ASSIGN",
      useAggregate: true,
      fil: JSON.stringify({ dates: { type: "AG_ASSIGN", value: "" } }),
    };
    dispatch(getAssignDataStart(action));
  };

  const shuffleTypeMap = {
    raToBdm: 1,
    equally: 2,
    range: 3,
  };

  // const payload = {
  //   coll: "Shuffle",
  //   payload: {
  //     date: new Date().toISOString(),
  //     shuffleType: shuffleTypeMap[selectedShuffleType] || 1,
  //     addedBy: Number(user.data.uiid),
  //     version: 1,
  //     shuffle: assignmentOutput.map((a) => ({
  //       BdmId: Number(a.bdm.id),
  //       assignedProspectData: [
  //         ...(a.teams.senior || []),
  //         ...(a.teams.junior || []),
  //         ...(a.teams.fresher || []),
  //       ].flatMap((team) => {
  //         const prospects = team.jobProspects || [];
  //         if (prospects.length > 0) {
  //           return prospects.map((jp) => ({
  //             raId: Number(team.id), // backend expects raId
  //             jobId: Number(jp.jobId) || null,
  //             prospectId: Number(jp.prospectId) || null,
  //           }));
  //         } else {
  //           return [{ raId: Number(team.id), jobId: null, prospectId: null }];
  //         }
  //       }),
  //     })),
  //   },
  // };

  const handleSave = () => {
    if (!assignmentOutput?.length) {
      console.warn("No assignments to save");
      return;
    }

    let prospectsList = [];

    const shuffleData = assignmentOutput.map(({ bdm, totalEmails, teams }) => {
      const assignedProspectData = Object.values(teams || {})
        .flat()
        .flatMap((team) => {
          const prospects =
            team.jobProspects?.map((jp) => ({
              raId: Number(team.id),
              jobId: Number(jp.jobId) || null,
              prospectId: Number(jp.prospectId) || null,
            })) || [];

          if (prospects.length) prospectsList.push(...prospects);
          return [{ raId: Number(team.id), jobId: null, prospectId: null }];
        });

      return {
        BdmId: Number(bdm.id),
        totalEmails: Number(totalEmails),
        assignedProspectData,
      };
    });

    const apiPayload = {
      coll: "Shuffle",
      payload: {
        date: new Date().toISOString(),
        shuffleType: shuffleTypeMap[selectedShuffleType] || 1,
        addedBy: Number(user.data.uiid),
        version: 1,
        shuffle: shuffleData.map(
          ({ BdmId, totalEmails, assignedProspectData }) => ({
            BdmId,
            assignedProspectData:
              totalEmails > 0
                ? [
                    ...assignedProspectData,
                    ...prospectsList.splice(0, totalEmails),
                  ]
                : assignedProspectData,
          }),
        ),
      },
    };

    console.log("apiPayload: ", apiPayload);

    dispatch(saveShuffleStart(apiPayload));
  };

  const isValidNumber = (value) =>
    value !== "" && !isNaN(value) && isFinite(Number(value));

  const handleApplyRange = () => {
    if (min === "" || max === "") {
      showToast("Both Min and Max values are required", "error");
      return;
    }
    if (!isValidNumber(min) || !isValidNumber(max)) {
      showToast("Min and Max must be valid numbers", "error");
      return;
    }
    if (Number(min) > Number(max)) {
      showToast("Min value cannot be greater than Max value", "error");
      return;
    }

    setValidatedRange({ min: Number(min), max: Number(max) });
  };

  // const isValidNumber = (value) =>
  //   value !== "" && !isNaN(value) && isFinite(Number(value));

  // const handleApplyRange = () => {
  //   if (min === "" || max === "") {
  //     showToast("Both Min and Max values are required", "error");
  //     return;
  //   }
  //   if (!isValidNumber(min) || !isValidNumber(max)) {
  //     showToast("Min and Max must be valid numbers", "error");
  //     return;
  //   }
  //   if (Number(min) > Number(max)) {
  //     showToast("Min value cannot be greater than Max value", "error");
  //     return;
  //   }

  //   setValidatedRange({ min: Number(min), max: Number(max) });
  // };

  useEffect(() => {
    fetchAssignData();
  }, [dispatch]);

  const transformedData = assignData
    ? {
        bdmList: assignData.map((bdm) => ({
          id: bdm.uiid,
          name: `${formatWords2(bdm.firstName)} ${formatWords2(bdm.lastName)}`,
          email: bdm.email?.primary || "",
        })),
        teamList: assignData.flatMap((bdm) =>
          bdm.raData.flatMap((category) =>
            (category.users || []).map((user) => ({
              id: `${user.uiid}`,
              name: formatWords2(user.firstName),
              designation:
                category.category === 1
                  ? "fresher"
                  : category.category === 2
                    ? "junior"
                    : "senior",
              prospectCount: user.jobs?.reduce(
                (sum, job) => sum + (job.prospectIds?.length || 0),
                0,
              ),
              assignedTo: bdm.uiid,
              jobProspects:
                user.jobs?.flatMap((job) =>
                  (job.prospectIds || []).map((pid) => ({
                    jobId: job.uiid ?? null,
                    prospectId: pid ?? null,
                  })),
                ) || [],
            })),
          ),
        ),
      }
    : null;

  const memoizedData = React.useMemo(
    () => transformedData || [],
    [transformedData],
  );

  const teamList = Array.isArray(memoizedData)
    ? []
    : memoizedData.teamList || [];
  const bdmList = Array.isArray(memoizedData) ? [] : memoizedData.bdmList || [];

  const designationCounts = teamList.reduce(
    (acc, team) => {
      if (team.designation === "senior") acc.senior += 1;
      else if (team.designation === "junior") acc.junior += 1;
      else if (team.designation === "fresher") acc.fresher += 1;
      return acc;
    },
    { senior: 0, junior: 0, fresher: 0 },
  );

  const totalEmails = teamList.reduce(
    (sum, team) => sum + (team.prospectCount || 0),
    0,
  );

  return (
    <div className="px-5 py-3">
      <div className="flex justify-end gap-4 items-center my-2">
        <FormFieldSet
          title="Shuffle"
          type="select"
          placeholder="RA to BDM"
          options={[
            { label: "RA to BDM", value: "default" },
            { label: "Equally", value: "equally" },
            { label: "Range", value: "range" },
          ]}
          value={selectedShuffleType}
          onChange={(val) => setSelectedShuffleType(val)}
          shadow={true}
        />
        {selectedShuffleType === "range" && (
          <div className="flex items-end gap-2">
            <div className="w-[120px]">
              <FormFieldSet
                title="Enter Range"
                shadow={true}
                placeholder="Min"
                value={min}
                onChange={(value) => setMin(value)}
              />
            </div>
            <div className="w-[120px]">
              <FormFieldSet
                title=""
                placeholder="Max"
                shadow={true}
                value={max}
                onChange={(value) => setMax(value)}
              />
            </div>
            <Button
              title={"Apply"}
              variant="outlined"
              onClick={handleApplyRange}
            />
          </div>
        )}
      </div>
      <InfoWrapper className={"min-w-60!"}>
        <InfoCardNewAdv
          layout="option8"
          title="Total BDM's"
          value={bdmList.length}
          icon="business_center"
          isLoading={loading}
        />
        <InfoCardNewAdv
          title="Senior RA"
          value={designationCounts.senior}
          icon="business_center"
          layout="option8"
          isLoading={loading}
        />
        <InfoCardNewAdv
          title="Junior RA"
          value={designationCounts.junior}
          icon="business_center"
          layout="option8"
          isLoading={loading}
        />
        <InfoCardNewAdv
          title="Fresher RA"
          value={designationCounts.fresher}
          icon="business_center"
          layout="option8"
          isLoading={loading}
        />
        <InfoCardNewAdv
          title="Emails Count"
          value={totalEmails}
          icon="business_center"
          layout="option8"
          isLoading={loading}
        />
        {/* <InfoCardNewAdv
          title="Emails Count"
          value={totalEmails}
          icon="business_center"
          layout="option8"
        /> */}
      </InfoWrapper>

      <div className="w-full overflow-x-auto ">
        <div className="min-w-[1100px]">
          <AssignTable
            showCheckbox
            key={JSON.stringify(memoizedData)}
            data={memoizedData}
            output={handleAssignmentOutput}
            shuffleType={selectedShuffleType}
            minEmails={validatedRange.min}
            maxEmails={validatedRange.max}
            toolbarRight={{
              search: false,
              filter: false,
              add: [
                {
                  component: (
                    <DropdownMenuNew
                      MenuSection={
                        <div className="flex flex-col">
                          <Button
                            title={"Download Option 1"}
                            variant="text"
                            color="black"
                            size="xs-sm"
                            className="!justify-start py-1"
                          />

                          <Button
                            title={"Download Option 2"}
                            variant="text"
                            color="black"
                            size="xs-sm"
                            className="!justify-start py-1"
                          />

                          <Button
                            title={"Download Option 3"}
                            variant="text"
                            color="black"
                            size="xs-sm"
                            className="!justify-start py-1"
                          />
                          <Button
                            title={"Download Option 4"}
                            variant="text"
                            color="black"
                            size="xs-sm"
                            className="!justify-start py-1"
                          />
                        </div>
                      }
                    >
                      <Button
                        type="icon"
                        variant="text"
                        icon={"download"}
                        color="black"
                      />
                    </DropdownMenuNew>
                  ),
                },
              ],
            }}
          />
        </div>
      </div>

      <div className="flex justify-end my-10">
        <Button title={"Save"} onClick={handleSave} />
      </div>
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default Assign;
